import { Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import TextFieldWithClear from '../TextFieldWithIcon/TextFieldWithIcon';

import styles from './styles.pcss';

type Props = {
  searchTransactions: Function;
  orgId: string | undefined;
};

export function TransactionQueryForm(props: Props) {
  const [postingDate, setPostingDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [amount, setAmount] = useState('');
  const [merchant, setMerchant] = useState('');
  const [last4, setLast4] = useState('');
  const [errorStatus, setErrorStatus] = useState('');

  const handleSearch = () => {
    if (!postingDate && (!startDate || !endDate)) {
      setErrorStatus(
        'You must enter either a posting date or start and end date to fetch transactions.',
      );
      return;
    }

    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (postingDate && !dateRegex.test(postingDate)) {
      setErrorStatus('Invalid date format. Please use yyyy-mm-dd.');
      return;
    }

    if (startDate && !dateRegex.test(startDate)) {
      setErrorStatus('Invalid date format. Please use yyyy-mm-dd.');
      return;
    }

    if (endDate && !dateRegex.test(endDate)) {
      setErrorStatus('Invalid date format. Please use yyyy-mm-dd.');
      return;
    }

    setErrorStatus('');
    props.searchTransactions(props.orgId, {
      amount,
      last4,
      merchant,
      postingDate,
      startDate,
      endDate,
    });
  };

  return (
    <>
      <h1>Transaction Finder</h1>
      <p>
        Enter transaction information to locate it in our database. You must
        enter either a posting date or start and end date to fetch transactions.
        All other fields are optional.
      </p>
      <div className={styles.inputRow}>
        <TextFieldWithClear
          className={styles.inputField}
          onChange={(event: any) => setPostingDate(event?.target?.value)}
          label="Posting Date"
          placeHolder="yyyy-mm-dd"
          variant="outlined"
          margin="normal"
          value={postingDate}
          onClear={() => setPostingDate('')}
          fullWidth={false}
        />
        <span className={styles.inputDivider}>OR</span>
        <TextFieldWithClear
          onChange={(event: any) => setStartDate(event?.target?.value)}
          label="Start Date"
          placeHolder="yyyy-mm-dd"
          variant="outlined"
          margin="normal"
          value={startDate}
          onClear={() => setStartDate('')}
          fullWidth={false}
        />
        <TextFieldWithClear
          onChange={(event: any) => setEndDate(event?.target?.value)}
          label="End Date"
          placeHolder="yyyy-mm-dd"
          variant="outlined"
          margin="normal"
          value={endDate}
          onClear={() => setEndDate('')}
          fullWidth={false}
        />
      </div>
      <div className={styles.inputRow}>
        <TextFieldWithClear
          onChange={(event: any) => setAmount(event?.target?.value)}
          label="Amount"
          variant="outlined"
          margin="normal"
          value={amount}
          onClear={() => setAmount('')}
          fullWidth={false}
        />
        <TextFieldWithClear
          onChange={(event: any) => setMerchant(event?.target?.value)}
          label="Merchant"
          variant="outlined"
          margin="normal"
          value={merchant}
          onClear={() => setMerchant('')}
          fullWidth={false}
        />
        <TextFieldWithClear
          onChange={(event: any) => setLast4(event?.target?.value)}
          label="Card Last 4 Digits"
          variant="outlined"
          margin="normal"
          value={last4}
          onClear={() => setLast4('')}
          fullWidth={false}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSearch}
        >
          Search
        </Button>
      </div>
      {errorStatus && <p style={{ color: 'red' }}>{errorStatus}</p>}
    </>
  );
}
